// src/components/Sidebar.js
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Box,
  useTheme,
} from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DnsIcon from "@mui/icons-material/Dns";
import TableRowsIcon from "@mui/icons-material/TableRows";

import { useNavigate, useLocation } from "react-router-dom";

const menuItems = [
  { id: 1, text: "Dashboard Utenti", icon: <DashboardIcon />, path: "/" },
  {
    id: 2,
    text: "Dashboard Associazioni",
    icon: <SpaceDashboardIcon />,
    path: "/associations",
  },
  {
    id: 3,
    text: "Codici associazioni",
    icon: <QrCodeIcon />,
    path: "/activation-code",
  },
  {
    id: 4,
    text: "Server",
    icon: <DnsIcon />,
    path: "/server",
  },
  {
    id: 5,
    text: "Logs",
    icon: <TableRowsIcon />,
    path: "/logs",
  },
];

export default function Sidebar() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: isMobile ? 60 : 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          mt: 2,
          width: isMobile ? 60 : 240,
          boxSizing: "border-box",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile ? "center" : "flex-start",
          backgroundColor: theme.palette.background.default, // <-- sfondo dinamico
        },
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          width: "100%",
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "center" : "flex-start",
          px: isMobile ? 0 : 2,
        }}
      >
        <img
          src={isMobile ? "/logo192.png" : "/logo.svg"}
          alt="logo"
          style={{
            width: isMobile ? 50 : 240,
            height: isMobile ? 50 : 70,
            objectFit: "cover",
          }}
        />
      </Box>

      {/* Menu */}
      <List sx={{ width: "100%" }}>
        {menuItems.map(({ text, icon, path }) => {
          const selected = location.pathname === path;

          return (
            <ListItem
              button
              key={text}
              onClick={() => navigate(path)}
              selected={selected}
              sx={{
                justifyContent: isMobile ? "center" : "flex-start",
                color: selected
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                "&.Mui-selected": {
                  backgroundColor: "transparent", // no background
                },
                "&.Mui-selected:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isMobile ? 0 : 2,
                  justifyContent: "center",
                  color: selected
                    ? theme.palette.primary.main
                    : theme.palette.text.primary,
                }}
              >
                {icon}
              </ListItemIcon>
              {!isMobile && <ListItemText primary={text} />}
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}
